import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { setDocumentDirection } from '../utils/rtlUtils';

import enTranslation from './locales/en/translation.json';
import hiTranslation from './locales/hi/translation.json';
import arTranslation from './locales/ar/translation.json';
import frTranslation from './locales/fr/translation.json';
import esTranslation from './locales/es/translation.json';
import zhTranslation from './locales/zh/translation.json';
import jaTranslation from './locales/ja/translation.json';
import koTranslation from './locales/ko/translation.json';
import bnTranslation from './locales/bn/translation.json';
import ptTranslation from './locales/pt/translation.json';
import mrTranslation from './locales/mr/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      hi: { translation: hiTranslation },
      ar: { translation: arTranslation },
      fr: { translation: frTranslation },
      es: { translation: esTranslation },
      zh: { translation: zhTranslation },
      ja: { translation: jaTranslation },
      ko: { translation: koTranslation },
      bn: { translation: bnTranslation },
      pt: { translation: ptTranslation },
      mr: { translation: mrTranslation }
    },
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transWrapTextNodes: '',
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'b']
    },
    // Clear any cached translations when language changes
    cleanCode: true,
    // Ensure proper language switching without caching issues
    load: 'languageOnly',
    // Only fallback to English if translation is missing (prevent fallback to Hindi when switching to Arabic)
    // eslint-disable-next-line no-dupe-keys
    fallbackLng: {
      'ar': ['en'],
      'hi': ['en'],
      'fr': ['en'],
      'es': ['en'],
      'zh': ['en'],
      'ja': ['en'],
      'ko': ['en'],
      'bn': ['en'],
      'pt': ['en'],
      'mr': ['en'],
      'en': ['en'],
      default: ['en']
    }
  })
  .then(() => {
    // Set initial RTL direction based on detected language
    const detectedLang = i18n.language || 'en';
    setDocumentDirection(detectedLang);
  });

// Set direction immediately if i18n is already initialized
if (i18n.isInitialized) {
  const currentLang = i18n.language || 'en';
  setDocumentDirection(currentLang);
} else {
  // Set direction once initialized
  i18n.on('initialized', () => {
    const currentLang = i18n.language || 'en';
    setDocumentDirection(currentLang);
  });
}

// Listen for language changes and update direction
i18n.on('languageChanged', (lng) => {
  setDocumentDirection(lng);
  // Clear any potential translation caches
  // Force React components to re-render by triggering a custom event
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('i18n:languageChanged', { detail: { language: lng } }));
  }
});

// Listen for loaded translations to ensure they're ready
i18n.on('loaded', () => {
  // Translations are loaded, components should re-render automatically via react-i18next
});

export default i18n;
